export const ALTERA_COR_REQUEST = 'ALTERA_COR_REQUEST';
export const ALTERA_COR_SUCCESS = 'ALTERA_COR_SUCCESS';
